import React from 'react';
import { Button } from 'src/components/Button/Button';

import classes from './GetAPrice.scss';

type Props = {
    onClick: () => void;
};

export const GetAPrice: React.FC<Props> = ({ onClick }) => (
    <div className={classes.container}>
        <h2 className={classes.header}>Get a Price</h2>
        <div className={classes.paragraphContainer}>
            <p className={classes.paragraph}>
                Use our instant quote system to see the full cost of your order. Just click here to get a bespoke quote,
                usually ready within a few hours. This includes customisation, delivery and VAT.
            </p>

            <Button className={classes.button} type="button" variant="primary" onClick={onClick}>
                Get a Price
            </Button>
        </div>
    </div>
);
